namespace advisorop.components.servicer {

    export class CashMonitorController {
        cashMonitorDetails: Array<any>;
        advisoryFirmId: number;
        pageLen: number;
        issuesCount: number;
        showNeto: boolean = true;
        dg: DevExpress.ui.dxDataGridOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;
        mvDate: Date = null;

        upToFive: number = 0;
        fiveToTwentyFive: number = 0;
        twentyFiveToFifty: number = 0;
        fiftyToSeventyFive: number = 0;
        seventyFiveToOneHundred: number = 0;

        // grid instance
        dgCashMonitor: DevExpress.ui.dxDataGrid;

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#cashMonitorContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        static $inject = ["servicerService", "generalService", "advisoryFirmApi"];
        constructor(
            private servicerService: services.ServicerService,
            private generalService: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "CashMonitor"
                },
                bindingOptions: {
                    dataSource: "vm.cashMonitorDetails",
                },
                //height: 400,
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: false
                },
                paging: {
                    pageSize: this.pageLen,
                    enabled: true
                },
                rowAlternationEnabled: true,
                //width: 1000,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: ""
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                onInitialized: function (e: any) {
                    //console.log('Initialising...');
                    this.dgCashMonitor = e.component;
                },
                wordWrapEnabled: true,

                columns: [
                    { dataField: "accountId", caption: "", cellTemplate: "colActions", width: 30 },
                    { dataField: "accountNumber", caption: "Account Number", width: 120 },
                    { dataField: "accountName", caption: "Account Name", width: 400 },
                    { dataField: "advisorNames", caption: "Advisor", width: 120 },
                    { dataField: "accountValue", caption: "Account Value", format: "currency", width: 80 },
                    { dataField: "cashBalance", caption: "Cash Balance", format: "currency", width: 80 },
                    { dataField: "cashPercentage", caption: "Cash %", format: { type: "percent", precision: 2 }, width: 80, sortIndex: 0, sortOrder: "desc" },
                ],
                masterDetail: {
                    enabled: true,
                    template: "sleeves",
                    autoExpandAll: false
                },
                onCellPrepared: this.oncp
            };

        }

        /**
         * report: AssetAllocation, Holdings, Performance, Transactions
         * level: will always be A-account or S-sleeve account
         * */
        openReport = (report: string, level: string, account: any) => {
            // console.log(`Report: ${report} Level ${level}, account: ${account}`);
            this.servicerService.calculateOrionParamsAsync(level, account.accountId).then(params => {
                this.servicerService.openOrionReport(report, params);
            });
        }

        oncp = function (e: any) {
            if (e.rowType === 'data' && e.column.command === 'expand') {
                if (!(e.row.data && e.row.data.sleeves && e.row.data.sleeves.length > 0)) {
                    e.cellElement.removeClass('dx-datagrid-expand');
                    e.cellElement.empty();
                }
            }
        }

        loadCashMonitor() {

            this.mvDate = null;

            let rez: any;

            this.isInitializing = true;

            this.upToFive = 0;
            this.fiveToTwentyFive = 0;
            this.twentyFiveToFifty = 0;
            this.fiftyToSeventyFive = 0;
            this.seventyFiveToOneHundred = 0;
            this.issuesCount = 0;

            if (this.advisoryFirmId && this.advisoryFirmId > 0) {
                //console.log("Loading cash monitor data for firm: " + this.advisoryFirmId);
                rez = this.servicerService.getCashMonitorData(this.advisoryFirmId);
            }

            rez.then(response => {
                this.cashMonitorDetails = response.data;
                //console.log("CashMonitorDetails:",this.cashMonitorDetails);
                if (this.cashMonitorDetails.length > 0) {
                    // The Market Value Date on all account rows is the same (date from the BO table), so we can take the date from the first row.
                    //this.mvDate = this.cashMonitorDetails[0].details.marketValueDate;
                    this.upToFive = response.data.filter(w => w.cashPercentage < .05).length;
                    this.fiveToTwentyFive = response.data.filter(w => w.cashPercentage > .05 && w.cashPercentage < .25).length;
                    this.twentyFiveToFifty = response.data.filter(w => w.cashPercentage > .25 && w.cashPercentage < .50).length;
                    this.fiftyToSeventyFive = response.data.filter(w => w.cashPercentage > .50 && w.cashPercentage < .75).length;
                    this.seventyFiveToOneHundred = response.data.filter(w => w.cashPercentage > .75).length;
                    this.issuesCount = this.cashMonitorDetails.length;
                }
                this.isInitializing = false;
            }, err => this.isInitializing = false)
            .catch(err => {
                this.generalService.showError(err);
            });
        };

        firmChanged(): void {
            this.advisoryFirmId = this.selFirm.id;
            this.loadCashMonitor();
        }

        $onInit(): void {
            this.advisoryFirmApi.getAdvisoryFirmsLight().then(response => {
                this.advisoryFirms = response.data;
                this.selFirm = this.advisoryFirms[0];
                this.firmChanged();
            }).catch(reason => {
            });
        }

        $onChanges(evt) {
            for (var key in evt) {
                //if (key === "advisoryFirmId" && this.advisoryFirmId) {
                //    console.log("Cash Monitor details data: ");
                //    console.log(this.cashMonitorDetails);
                //}
            }
        };
    }


    class CashMonitor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<",
                pageLen: "<",
                issuesCount: "="
            };
            this.controller = CashMonitorController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/cash-monitor.html";
        }
    }
    angular.module(Constants.APP).component("cashMonitor", new CashMonitor());

}